import * as yup from "yup";
import { removeHtmlTagsAndEntities } from "../utils";

export const schema = yup.object({
    subject: yup.string().required("subject is required"),
    message: yup
      .string()
      .required("Description is required")
      .test(
        "no-only-spaces",
        "Description is required",
        (value) => removeHtmlTagsAndEntities(value).trim().length > 0
      ),
  });